import React, { useEffect, useRef, useState } from 'react';
import {
    ListItem,
    IconButton,
    Menu,
    MenuItem,
    Tooltip
} from '@mui/material';
import "../../ChatHistory/ChatHistory.scss";
import DotsMenu from "../../../assets/images/vactor/dot-menu.svg";

interface Conversation {
    conversation_id: string;
    title: string;
    formatted_date?: string;
    messages?: Array<{
        prompt?: string;
    }>;
}

interface ConversationListItemProps {
    conversation: Conversation;
    handleClickMoreMenu: any;
    handleCloseMoreMenu: any;
    handleDeleteConversation: (id: string) => void;
    handleRenameConversation: (id: string, newTitle: string) => void; // Add this back
    handleGetConversationId: (id: string) => void;
    moreMenu: any;
    open: boolean;
    activeConversationId:any;
    currentConversationId: string | null;
}

const ConversationListItem: React.FC<ConversationListItemProps> = ({
    conversation,
    handleClickMoreMenu,
    handleCloseMoreMenu,
    handleDeleteConversation,
    handleRenameConversation,
    handleGetConversationId,
    moreMenu,
    open,
    activeConversationId,
    currentConversationId
}) => {
    const [isEditing, setIsEditing] = useState<any>();
    const [editedTitle, setEditedTitle] = useState<string>("");
    const inputRef = useRef<HTMLInputElement>(null);
    const titleRef = useRef<HTMLSpanElement>(null);
    const [showTitleTooltip, setShowTitleTooltip] = useState(false);
    const fullTitle =
        editedTitle.trim() ||
        conversation.title?.trim() ||
        conversation.messages?.find((message) => message?.prompt)?.prompt ||
        "No content provided";

    useEffect(() => {
        setEditedTitle(conversation.title || "No content provided");
    }, [conversation.conversation_id, conversation.title]);

    useEffect(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isEditing]);

    useEffect(() => {
        const titleElement = titleRef.current;
        if (!titleElement) return;

        setShowTitleTooltip(titleElement.scrollWidth > titleElement.clientWidth);
    }, [editedTitle, isEditing]);

    const handleRenameClick = () => {
        setIsEditing(true); 
        handleCloseMoreMenu();
      
    };

    const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        setEditedTitle(e.target.value);
    };

    const handleTitleBlur = (e: any) => {
        e.stopPropagation();
        if (editedTitle.trim() && editedTitle.trim() !== conversation.title) {
            handleRenameConversation(conversation.conversation_id, editedTitle.trim());
        } else {
            setEditedTitle(conversation.title||"No content provided"); 
        }
        setIsEditing(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleTitleBlur(e);
        } else if (e.key === 'Escape') {
            setEditedTitle(conversation.title||"No content provided");
            setIsEditing(false);
        }
    };
    const handleTitleClick = (e: React.MouseEvent) => {
        if (!isEditing) {
            localStorage.setItem("conver_ID", conversation.conversation_id);
            handleGetConversationId(conversation.conversation_id);
        }
    };
    return (
        <ListItem className={conversation.conversation_id === currentConversationId ? "active" : ""}>

            <div className="rename-text-field-items">
                {isEditing ? (
                    <input
                        ref={inputRef}
                        className={`input-rename-text-field ${conversation.conversation_id === currentConversationId ? "active-input-rename-text-field" : ""}`}
                        value={editedTitle}
                        type="text"
                        id={`input-${conversation.conversation_id}`}
                        onChange={handleTitleChange}
                        onBlur={handleTitleBlur}
                        onKeyDown={handleKeyDown}
                    />
                ) : (
                    <Tooltip
                        title={
                            <span
                                style={{
                                    display: "block",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "normal",
                                }}
                            >
                                {fullTitle}
                            </span>
                        }
                        arrow
                        disableHoverListener={!showTitleTooltip}
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    width: "240px",
                                    maxWidth: "240px",
                                    fontSize: "13px",
                                    lineHeight: "18px",
                                    padding: "8px 12px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "normal",
                                },
                            },
                        }}
                        slotProps={{
                            tooltip: {
                                sx: {
                                    width: "240px",
                                    maxWidth: "240px",
                                    fontSize: "13px",
                                    lineHeight: "18px",
                                    padding: "8px 12px",
                                    whiteSpace: "normal",
                                    overflowWrap: "anywhere",
                                    wordBreak: "normal",
                                },
                            },
                        }}
                    >
                        <span
                            ref={titleRef}
                            className={`input-rename-text-field ${conversation.conversation_id === currentConversationId ? "active-input-rename-text-field" : ""}`}
                            onClick={handleTitleClick}
                            style={{ cursor: 'pointer', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        >
                            {editedTitle}
                        </span>
                    </Tooltip>
                )}

                <IconButton
                    edge="end"
                    aria-label="menu"
                    id={`moremenu-button-${conversation.conversation_id}`}
                    aria-controls={open ? "basic-moremenu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={(e: React.MouseEvent<HTMLElement>) => {
                        e.stopPropagation();
                        handleClickMoreMenu(e, conversation);
                    }}
                >
                    <img src={DotsMenu} alt="menu" />
                </IconButton>
                <Menu
                    className="moremenu-popup"
                    id={`basic-moremenu-${conversation.conversation_id}`}
                    anchorEl={moreMenu.id === conversation.conversation_id ? moreMenu.element : null}
                    open={open}
                    onClose={handleCloseMoreMenu}
                    MenuListProps={{
                        "aria-labelledby": "moremenu-button",
                    }}
                >
                    <MenuItem onClick={(e) => {
                        e.stopPropagation()
                        handleRenameClick()
                    }}>
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 14 16"
                                fill="none"
                            >
                                <path
                                    d="M2.8105 11.0001L10.417 3.39356L9.3565 2.33306L1.75 9.93956V11.0001H2.8105ZM3.43225 12.5001H0.25V9.31781L8.82625 0.741563C8.9669 0.600959 9.15763 0.521973 9.3565 0.521973C9.55537 0.521973 9.7461 0.600959 9.88675 0.741563L12.0085 2.86331C12.1491 3.00396 12.2281 3.19469 12.2281 3.39356C12.2281 3.59244 12.1491 3.78317 12.0085 3.92381L3.43225 12.5001ZM0.25 14.0001H13.75V15.5001H0.25V14.0001Z"
                                    fill="#525866"
                                />
                            </svg>
                        </span>
                        <span className="moremenu-text"><span>Rename</span></span>
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            handleDeleteConversation(conversation.conversation_id);
                            handleCloseMoreMenu();
                        }}
                    >
                        <span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    d="M13.75 5.5H17.5V7H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V7H2.5V5.5H6.25V3.25C6.25 3.05109 6.32902 2.86032 6.46967 2.71967C6.61032 2.57902 6.80109 2.5 7 2.5H13C13.1989 2.5 13.3897 2.57902 13.5303 2.71967C13.671 2.86032 13.75 3.05109 13.75 3.25V5.5ZM14.5 7H5.5V16H14.5V7ZM7.75 9.25H9.25V13.75H7.75V9.25ZM10.75 9.25H12.25V13.75H10.75V9.25ZM7.75 4V5.5H12.25V4H7.75Z"
                                    fill="#DF1C41"
                                />
                            </svg>
                        </span>
                        <span className="moremenu-text delete-menu"><span>Delete</span></span>
                    </MenuItem>
                </Menu>
            </div>
        </ListItem>
    );
};

export default ConversationListItem;
